import { useEffect, useState } from "react";

function formatElapsed(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

/** Live-updating MM:SS (or H:MM:SS) label from an ISO start timestamp. */
export function useElapsedSinceLabel(startedAt: string | null | undefined): string {
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (!startedAt) {
      setLabel("");
      return;
    }
    const tick = () => {
      const startMs = new Date(startedAt).getTime();
      const sec = Math.max(0, Math.floor((Date.now() - startMs) / 1000));
      setLabel(formatElapsed(sec));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [startedAt]);

  return label;
}
